module.exports = __webpack_public_path__ + "static/media/thumbs_up.bdf59f13.png";